module.exports = __webpack_public_path__ + "static/media/whatsapp@2x.bd49cef5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagenes/sobrePedraza/redes/whatsapp@2x.png
// module id = 238
// module chunks = 0